import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../../Theming/Theming';
import CloseButton from '../../../ui/CloseButton';
import MobileCategories from './MobileCategories';
import UIDrawer from '@jetshop/ui/Modal/Drawer/Drawer';
import DrawerHeader from '../../../ui/DrawerHeader';
import Logo from '../Logo';
import ChannelSelectorModal from '../ChannelSelector/ChannelSelectorModal';
import { useSiteContent } from '../../../Util/useSiteContent';
import { LoginWidget } from '../Util/LoginWidget';

const StyledCloseButton = styled(CloseButton)`
  padding: 10px;
  margin: -10px;
`;

const Scroll = styled('div')`
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  flex: 1 1 auto;
  padding-bottom: 30px;
`;

const MobileNavWrapper = styled('div')`
  height: 100%;
`;

const StyledDrawerHeader = styled(DrawerHeader)`
  background: ${theme.colors.white};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${theme.mobileHeader.nav.padding};
  margin: 1rem 0;
  border: none;
`;

const LogoWrapper = styled('div')`
  padding: 10px 0;
  max-width: 100%;
  width: 100px;
  position: relative;
  left: 0px;
`;

const SiteList = styled('div')`
  margin-top: 3rem;
  padding: 0 ${theme.mobileHeader.nav.padding};
  > h3 {
    margin: 0 0 0.5rem 0;
  }
  ul {
    li {
      display: block;
      line-height: 42px;
      text-decoration: none;
      border-bottom: 1px solid ${theme.colors.border};
    }
  }
`;

const ChannelSelectorWrapper = styled('div')`
  padding: 0 1rem;
  margin-top: 2rem;
  display: none;
`;

const MobileNav = ({
  categories,
  categoryTreeRoots,
  hideTarget,
  isOpen,
  right,
  ...rest
}) => {
  const item = useSiteContent(['MobilePageList']);
  return (
    <UIDrawer isOpen={isOpen} right={right} size={360}>
      <MobileNavWrapper>
        <StyledDrawerHeader>
          <LogoWrapper>
            <Logo mobile={true} />
          </LogoWrapper>
          <StyledCloseButton onClick={hideTarget} />
        </StyledDrawerHeader>
        <Scroll>
          <MobileCategories
            hideTarget={hideTarget}
            categories={categoryTreeRoots}
            categoryTreeRoots={categoryTreeRoots}
            isOpen={isOpen}
          />
          <ChannelSelectorWrapper>
            <ChannelSelectorModal />
          </ChannelSelectorWrapper>
          {item && <SiteList onClick={hideTarget}>{item.html}</SiteList>}
          <SiteList onClick={hideTarget}>
            <LoginWidget />
          </SiteList>
        </Scroll>
      </MobileNavWrapper>
    </UIDrawer>
  );
};
export default MobileNav;
